import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Redirect } from 'react-router-dom';
export const getAuthenticatedRoute = ({ isAuthenticated, redirectTo, }) => (_a) => {
    var { component: Component } = _a, rest = __rest(_a, ["component"]);
    const routeProps = {
        render: (props) => {
            if (Component && isAuthenticated()) {
                return _jsx(Component, Object.assign({}, props), void 0);
            }
            // eslint-disable-next-line no-console
            console.debug(`Redirecting for unauthenticated from ${props.location.pathname}${props.location.search}`);
            return (_jsx(Redirect, { to: {
                    pathname: redirectTo,
                    state: { from: props.location },
                } }, void 0));
        },
    };
    return _jsx(Route, Object.assign({}, rest, routeProps), void 0);
};
//# sourceMappingURL=getAuthenticatedRoute.js.map